(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('profil-contrat', {
            parent: 'entity',
            url: '/profil-contrat?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'wamasysApp.contractProfil.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/profil-contrat/profil-contrats.html',
                    controller: 'ContractProfilController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('contractProfil');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('profil-contrat-detail', {
            parent: 'entity',
            url: '/profil-contrat/{id}',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.contractProfil.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/profil-contrat/profil-contrat-detail.html',
                    controller: 'ContractProfilDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('contractProfil');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ContractProfil', function($stateParams, ContractProfil) {
                    return ContractProfil.get({id : $stateParams.id});
                }]
            }
        })
        .state('profil-contrat.new', {
            parent: 'profil-contrat',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/profil-contrat/profil-contrat-dialog.html',
                    controller: 'ContractProfilDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                libelle: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('profil-contrat', null, { reload: true });
                }, function() {
                    $state.go('profil-contrat');
                });
            }]
        })
        .state('profil-contrat.edit', {
            parent: 'profil-contrat',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/profil-contrat/profil-contrat-dialog.html',
                    controller: 'ContractProfilDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ContractProfil', function(ContractProfil) {
                            return ContractProfil.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('profil-contrat', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('profil-contrat.delete', {
            parent: 'profil-contrat',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/profil-contrat/profil-contrat-delete-dialog.html',
                    controller: 'ContractProfilDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ContractProfil', function(ContractProfil) {
                            return ContractProfil.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('profil-contrat', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
